import { PaginatedData } from '@base/wrappers/paginated-data';
import { UseCase } from '@domain/base/use-case';
import { TravelPlanState, TravelPlanShortModel } from '@domain/models/travel-plan.model';
import { TravelPlanRepository } from '@domain/repositories/travel-plan.repository';
import { Observable } from 'rxjs';



export class GetTravelPlansUseCase
  implements
    UseCase<
      {
        userId:string;
        state: TravelPlanState;
        pageNumber?: number;
        pageSize?: number;
      },
      PaginatedData<TravelPlanShortModel>
    >
{
  constructor(private travelPlanRepository: TravelPlanRepository) {}

  execute(params: {
    userId:string;
    state: TravelPlanState;
    pageNumber?: number;
    pageSize?: number;
  }): Observable<PaginatedData<TravelPlanShortModel>> {
    return this.travelPlanRepository.getPlans(
      params.userId,
      params.state,
      params.pageNumber ?? 1,
      params.pageSize ?? 100
    );
  }
}
